<template>
  <div class="text-xs-center">
    <v-dialog
      :value="value"
      @input="$emit('input')"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2 py-2"
          primary-title
        >
          Setar Tipo Atividade
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn
              flat
              fab
              small
              icon
              @click="$emit('input')"
              slot="activator"
            >
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-autocomplete
            v-model="tipoAtividade"
            :items="tiposAtividade"
            item-text="Descricao"
            return-object
            menu-props="auto"
            label="Tipo Atividade"
            hide-details
            prepend-icon="description"
            class="mb-3"
            auto-select-first
            no-data-text="Registro não encontrado."
          ></v-autocomplete>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
  props: ['value', 'atividade', 'loading'],
  data() {
    return {
      tipoAtividade: null
    }
  },
  methods: {
    ...mapActions(['fetchTiposAtividade']),
    ...mapMutations([
      'showNotification'
    ]),
    adiciona() {
      if (this.tipoAtividade) {
        if (this.atividade !== null) {
          this.atividade.IdTipoAtividade = this.tipoAtividade.IdTipoAtividade;
          this.atividade.TipoAtividade = this.tipoAtividade.Descricao;
          this.$emit('setaTipoAtividade', this.atividade);
          this.tipoAtividade = null;
        } else {
          this.$emit('setaTipoAtividadeSelected', this.tipoAtividade);
          this.tipoAtividade = null;
        }
      } else {
        this.showNotification({ text: 'Informe o tipo de atividade', status: 'error' });
      }
    }
  },
  computed: {
    ...mapGetters(['tiposAtividade'])
  },
  async created() {
    if (!this.tiposAtividade.length) {
      await this.fetchTiposAtividade();
    }
  }
}
</script>

<style>

</style>
